import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import store from './store/store';
import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { BaseProvider, Theme } from '@epo/epods-react-components/lib/Themes';
import { Spinner } from '@epo/epods-react-components/lib/Components/Spinner';
import { RouterProvider } from "react-router-dom";
import IntlMessagesProvider from './providers/IntlMessageProvider.provider'
import router from './routes/router';
import Configs from './configs';

import '@epo/epods-react-components/lib/CSS/base-host.min.css'
import '@epo/epods-react-components/lib/CSS/fontface-epoicons-full.min.css'
import '@epo/epods-react-components/lib/CSS/components.min.css'
import '@epo/epods-react-components/lib/CSS/grid.min.css'
import '@epo/epods-react-components/lib/CSS/utilities-responsive.min.css'
import '@epo/epods-react-components/lib/CSS/utilities.min.css'
import '@epo/epods-react-components/lib/CSS/components-primereact.min.css';
import './assets/css/index.css'

const engine = new Styletron({ prefix: Configs.PROJECT_NAMESPACE });

ReactDOM.render(
    <Provider store={store}>
        <StyletronProvider value={engine}>
            <BaseProvider theme={Theme}>
                <IntlMessagesProvider>
                    <RouterProvider router={router} fallbackElement={<Spinner size="large" />} />
                </IntlMessagesProvider>
            </BaseProvider>
        </StyletronProvider>
    </Provider>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
